var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          {
            staticClass:
              "rental-card-wide rental-card-loading boxed-widget--clean boxed-widget--mobile",
          },
          [_c("i", { staticClass: "fa fa-spinner fa-pulse" })]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }